var path = 'directives/modal.html';
var html = "<div class=modal data-ng-show=visible> <div class=modalBackground data-ng-click=hide()></div> <button class=\"modalClose btn btn--inverse btn--noRadius fa fa-times-circle\" data-ng-click=hide()></button> <div class=modalContentWrap ng-transclude> </div> </div>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./views/directives/modal.html
// module id = +DAV
// module chunks = 1 2